import { render, staticRenderFns } from "./CompetitivePricingCaseStudyScreen.vue?vue&type=template&id=cc64431c"
import script from "./CompetitivePricingCaseStudyScreen.vue?vue&type=script&lang=js"
export * from "./CompetitivePricingCaseStudyScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports